import type { UserRole } from '@/types/user';

const ROLE_IMPLICATIONS: Record<UserRole, UserRole[]> = {
  ADMIN: ['ADMIN', 'MARKETING', 'HR', 'BENEFICIARY'],
  MARKETING: ['MARKETING', 'BENEFICIARY'],
  HR: ['HR', 'BENEFICIARY'],
  BENEFICIARY: ['BENEFICIARY'],
  INTEGRATION: ['INTEGRATION'],
};

export const isAtLeastRole = (
  userRole: UserRole | undefined,
  requiredRole: UserRole,
): boolean => {
  if (!userRole) {
    return false;
  }

  // Exact match first (handles roles outside hierarchy like INTEGRATION)
  if (userRole === requiredRole) {
    return true;
  }

  // Check if the user's role implies the required role
  const implied = ROLE_IMPLICATIONS[userRole];
  return Boolean(implied && implied.includes(requiredRole));
};
